import UltMeta, { Meta } from "./UltMeta/index";

/**
 *处理状态
 */
class ProcessState extends UltMeta {
    PENDING = new Meta(1, "待处理");
    PROCESSING = new Meta(2, "处理中");
    PROCESSED = new Meta(3, "已处理");
}
export const PROCESS_STATE = new ProcessState();

/**
 *发布类型
 */
class featuresFeedbackPublishType extends UltMeta {
    RESOURCE_FEEDBACK = new Meta(1, "货源反馈");
    BOAT_OWNER_CANCELLED = new Meta(2, "船主取消报价");
    SHIPPER_CANCELLED = new Meta(3, "货主取消找船需求");
}
export const FEATURES_FEEDBACK_PUBLISH_TYPE = new featuresFeedbackPublishType();

/**
 * 用户选择反馈类型
 */
class FeedbackType extends UltMeta {
    TIME_INAPPROPRIATE = new Meta(1, "时间不合适");
    PRICE_TOO_LOW = new Meta(2, "价格太低");
    BOAT_FOUND = new Meta(3, "已找到船");
    BOAT_INAPPROPRIATE = new Meta(4, "船不合适");
    REQUIREMENTS_UNREASONABLE = new Meta(5, "要求不合理");
    MISTAKE_OPERATION = new Meta(6, "误操作,看错时间、路线");
    INFORMATION_ERROR = new Meta(7, "填写信息有误");
    CARGO_FOUND = new Meta(8, "已找到货");
    WAIT_TIME_TOO_LONG = new Meta(9, "等待时间太长");
    BOAT_DEMAND_CANCELLED = new Meta(10, "用船需求取消");
    FEES_INAPPROPRIATE = new Meta(11, "费用不合适(定金、信息服务费)");
    ALTERNATIVE_CHANNEL_FOUND = new Meta(12, "已通过其他渠道找到船");
    SERVICE_EXPERIENCE_UNSATISFACTORY = new Meta(13, "服务体验不佳");
}

export const FEEDBACK_TYPE = new FeedbackType();
